import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import StyledButton from "../../../../common/models/Button";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { appUrl } from "../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },

  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "600px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "12px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // optional, centers them horizontally
    gap: "12px", // space between buttons
    marginTop: "24px", // spacing from the top if needed
  },
  resetChangesButton: {
    border: "1px solid #000000",
    color: "#000000",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  iconBtn: {
    padding: "0.5px",
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
}));

const ManufacturingSupplyTab = (props) => {
  const { featuresAccess, sponsorId } = props;
  const classes = useStyles();
  const [modalities, setModalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAddRow, setShowAddRow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  
  // Get edit access from featuresAccess
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      // Open backdrop logic would go here
      //console.log("Opening backdrop");
    } else if (action.type === "DESTROY_BACKDROP") {
      // Close backdrop logic would go here
      //console.log("Closing backdrop");
    }
  };

  // Constants for backdrop dispatch
  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  // ✅ Fetching from API
  const fetchProductTypes = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantSupplyTypesDirect/false`;
      const response = await axios.get(url);

      if (response.data?.data?.status) {
        const list = response.data.data.supplyTypeList || [];
        const formatted = list.map((item, index) => ({
          ...item,
          id: item.supplyTypeID || `ID-${index + 1}`,
          name: item.supplyTypeName || "",
          selected: !!item.activated,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || "",
          type: item.supplyType ,
        }));

        setModalities(formatted);
      } else {
        setError("Something went wrong. Please try again.");
        console.error("Failed to fetch product types");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
      console.error("Error fetching product types:", error);
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };

  useEffect(() => {
    fetchProductTypes();
  }, []);

  // const handleNextClick = async () => {
  //   // Check if at least one modality is toggled
  //   const toggledModalities = modalities.filter(
  //     (modality) => modality.isUpdated
  //   );
  //   console.log(toggledModalities, "toggledModalities");

  //   if (!toggledModalities.length) {
  //     console.log("No updates detected. Proceeding to the next step.");
  //     props.handleNext(); // Directly move to the next tab
  //     return;
  //   }
  //   // if (!isAnyModalityToggled.length) {
  //   //   setErrorMessage("Please enable at least one toggle mode.");
  //   //   return;
  //   // }
  //   if (modalities.every((modality) => !modality.selected)) {
  //     setErrorMessage("Please enable at least one in toggle mode.");
  //     return;
  //   }

  //   setErrorMessage("");

  //   if (isUpdated) {
  //     // Call the update API if data is updated
  //     try {
  //       const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateSupplyTypes`;
  //       // const payload = modalities.map(({ id, selected }) => ({
  //       //   drugTypeID: id,
  //       //   activated: selected,
  //       // }));
  //       const payload = {
  //         sponsorId: 2,
  //         ecosystemId: 1,
  //         supplyTypeList: toggledModalities.map(({ id, selected, isNew }) => ({
  //           supplyTypeID: id,
  //           activated: selected,
  //           markForDelete: isNew ? false : false, // Adjust delete logic as needed
  //         })),
  //       };

  //       await axios.post(url, payload);
  //       fetchProductTypes();
  //       props.handleNext();

  //       console.log("Modalities updated successfully");
  //     } catch (error) {
  //       console.error("Error updating modalities:", error);
  //       setErrorMessage("Failed to update modalities. Please try again.");
  //       return;
  //     }
  //   }

  //   // Proceed to the next step
  //   console.log("Proceeding to the next step...");
  //   // ...existing code for navigating to the next step...
  // };
  const handleSaveChanges = async () => {
    // Check if any modalities are updated
    const toggledModalities = modalities.filter(
      (modality) => modality.isUpdated
    );

    if (!toggledModalities.length) {
      return;
    }

    if (modalities.every((modality) => !modality.selected)) {
      setErrorMessage("Please enable at least one in toggle mode.");
      return;
    }

    setErrorMessage("");

    if (isUpdated) {
      try {
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSupplyTypes`;
        const payload = {
          sponsorId: sponsorId,
          ecosystemId: localStorage.getItem("ecosystemId"),
          supplyTypeList: toggledModalities.map(({ id, selected, isNew }) => ({
            supplyTypeID: id,
            activated: selected,
            markForDelete: isNew ? false : false,
          })),
        };

        await axios.post(url, payload);
        fetchProductTypes();
        setErrorMessage("");
      } catch (error) {
        setErrorMessage("Failed to update modalities. Please try again.");
        return;
      }
    }
  };
  const deleteProductTypes = async (modality) => {
    //console.log(modality, "deleteModality");
    //console.log(modality, "modality");
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSupplyTypes`;

      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        supplyTypeList: [
          {
            supplyTypeID: modality.id,
            supplyTypeName: modality.name,
            activated: modality.selected,
            markForDelete: true,
          },
        ],
      };
      if (modality.isNew !== true) {
        const response = await axios.post(url, payload);
        fetchProductTypes();
         props.setManufacturingSupplyTypes((prev) => !prev); 
      } else {
        const updated = modalities.filter((item) => item.id !== modality.id);
        setModalities(updated);
      }
    } catch (error) {
      console.error("Error saving modalities:", error);
      return false;
    }
  };
  const saveNewModality = async (modality) => {
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addPlantSupplyTypes`;

      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        supplyTypeList: [
          {
            supplyTypeName: modality.name,
            supplyType: "New",
            activated: modality.selected,
          },
        ],
      };

      const response = await axios.post(url, payload);
      fetchProductTypes();
      props.setManufacturingSupplyTypes((prev) => !prev); 

      return response.data?.data?.status === true;
    } catch (error) {
      return false;
    }
  };

  const handleToggle = (index) => {
    const updated = [...modalities];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setModalities(updated);
    setIsUpdated(true);
  };
  const [savingStates, setSavingStates] = useState({}); // Track saving state per index

  const handleNameChange = (index, value) => {
    const updated = [...modalities];
    updated[index].name = value;
    setModalities(updated);
    setIsUpdated(true);
  };

  // const handleDelete = (index) => {
  //   const newModalities = modalities.filter((_, i) => i !== index);
  //   setModalities(newModalities);
  // };

  const handleAddModality = () => {
    //const nextId = (modalities.length + 1).toString().padStart(2, "0");
    setModalities([
      ...modalities,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
    setShowAddRow(true);
  };

const handleSaveNew = async (index) => {
  const modality = modalities[index];
  
  // Return early if already saving or if name is empty
  if (!modality.name?.trim() || savingStates[index]) return;
  
  // Set saving state BEFORE the API call to prevent multiple clicks
  setSavingStates(prev => ({ ...prev, [index]: true }));
  
  try {
    const success = await saveNewModality(modality);

    if (success) {
      // Refresh full list from API after successful save
      await fetchProductTypes();
    }
  } catch (error) {
    console.error("Error saving modality:", error);
  } finally {
    // Always clear saving state when done (whether success or failure)
    setSavingStates(prev => ({ ...prev, [index]: false }));
  }
};

  const handleCancel = (index) => {
    const updated = modalities.filter((_, i) => i !== index);
    setModalities(updated);
  };
  const handleResetChanges = () => {
    if (isUpdated) {
      fetchProductTypes();
      setIsUpdated(false);
      setErrorMessage("");
    }
  };
  //console.log(modalities, "ManufacturingSupplyTab", "modalities");

  return (
    <div>
      {/* Table and Buttons Section */}
      <div style={{ display: "flex", gap: "100px", alignItems: "flex-start" }}>
        <div className={`${classes.container} default-table-styles`}>
          <Table className={`${classes.table} default-table-styles`}>
            <TableHead>
              <TableRow>
                <TableCell className={`${classes.headerCell} default-table-styles`}>Selection</TableCell>
                <TableCell className={`${classes.headerCell} default-table-styles`} style={{ whiteSpace: "nowrap" }}>
                  Manufacturing Supply Type
                </TableCell>
                <TableCell className={`${classes.headerCell} default-table-styles`} style={{ whiteSpace: "nowrap" }}>
                  Manufacturing Supply Type ID
                </TableCell>
                <TableCell className={`${classes.headerCell} default-table-styles`}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100px",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  </TableCell>
                </TableRow>
              ) : error ? (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50px",
                        border: "2px solid #FF0000",
                        backgroundColor: "#FFF0F0",
                        width: "100%",
                      }}
                    >
                      <Typography style={{ textAlign: "center" }}>
                        {error}
                      </Typography>
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                modalities.map((modality, index) => (
                  <TableRow key={modality.id}>
                    <TableCell className={classes.bodyCell}>
                      <Switch
                        checked={modality.selected}
                        onChange={() => handleToggle(index)}
                        classes={{ switchBase: classes.switchBase }}
                        disabled={!canEdit}
                      />
                    </TableCell>
                    <TableCell className={classes.bodyCell}>
                      {modality.isNew ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <TextField
                            placeholder="Type Text Here"
                            value={modality.name}
                            onChange={(e) =>
                              handleNameChange(index, e.target.value)
                            } 
                            onBlur={(e) => {
                              const { value } = e.target;
                              // Trim leading and trailing spaces for string values
                              if (typeof value === "string" && value.trim() !== value) {
                                handleNameChange(index, value.trim());
                              }
                            }}
                            className={classes.textField}
                            variant="outlined"
                            inputProps={{
                              onBeforeInput: (e) => {
                                const allowedChars = /^[a-zA-Z\s\-\/,().]+$/;
                                if (!allowedChars.test(e.data)) {
                                  e.preventDefault();
                                }
                              }
                            }}
                          />
                          <div className={classes.inlineActions}>
                            <IconButton
                              onClick={() => handleCancel(index)}
                              className={classes.iconBtn}
                            >
                              <CancelIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              onClick={() =>{
                                if (!modality.name.trim()) return;
 handleSaveNew(index)
                              }}
                              className={classes.iconBtn}
                              style={{
    cursor: modality.name.trim() ? "pointer" : "default",
  }}
                              disabled={!modality.name.trim() || modalities.some((m, i) => 
                                i !== index && m.name?.trim().toLowerCase() === modality.name.trim().toLowerCase()) || savingStates[index]
                              }
                            >
                              <SaveIcon fontSize="small" />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        modality.name
                      )}
                    </TableCell>
                    <TableCell className={classes.bodyCell}>
                      {modality.id}
                    </TableCell>
                    <TableCell className={classes.bodyCell}>
                      {canEdit && (modality.isNew == true ||
                        (modality.type === "New" && modality.lastUpdatedBy !== "support@schrocken.com")) && (
                        <IconButton
                          aria-label="delete"
                          onClick={() => deleteProductTypes(modality)}
                        >
                          <DeleteIcon className={classes.deleteIcon} />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
        <div
          className={classes.buttonContainer}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px", // Adjusted gap between buttons
            marginTop: "3px",
            marginLeft: "0rem", // Added margin to create space between table and buttons
          }}
        >
          <Button
            className={classes.saveButton}
            type="button"
            onClick={handleSaveChanges}
            disabled={!isUpdated || !canEdit}
            style={{
    
    opacity: !isUpdated || !canEdit ? 0.7 : 1, // Fade out when disabled
    color: "#fff", 
  }}
          >
            Save Selection
          </Button>

          <Button
            className={classes.resetChangesButton}
            type="button"
            onClick={handleResetChanges}
               disabled={!isUpdated || !canEdit} // or whatever your "no changes" condition is
  style={{
    opacity: !isUpdated || !canEdit ? 0.8 : 1, // Fade out when disabled
  }}
          >
            Reset Selection
          </Button>
        </div>
      </div>

      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}

      {canEdit && (
        <Button
          variant="outlined"
          onClick={handleAddModality}
          className={classes.addButton}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New Manufacturing Supply Type
        </Button>
      )}
    </div>
  );
};

export default ManufacturingSupplyTab;
